import React from "react";
import PropTypes from "prop-types";
import Fade from "react-reveal/Fade";

const ProjectDetails = ({ details }) => {
  return (
    <Fade bottom>
      <figure className="headline__projects--display">
        <img src={details.img} />
        <div className="headline__projects--display__info">
          <h2>{details.title}</h2>
          <a href={details.link}>
            <p>View Site</p>
          </a>
          <a href={details.source}>
            <p>View Source</p>
          </a>
        </div>
      </figure>
    </Fade>
  );
};

export default ProjectDetails;



// WEBPACK FOOTER //
// ./src/component/Projects/ProjectDetails.js